import {copyToClipboard, IconButton} from 'platform/components';
import {HStack, Text} from 'platform/foundation';

import {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import {selectActiveBranchId} from '@dms/api/features';
import {browserStorageKey} from '@dms/config';

import {getFixedTranslation} from '../utils/getFixedTranslation';

const ACCESS_TOKEN_KEY = browserStorageKey.ACCESS_TOKEN;

function readAccessToken(): string | null {
  return typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(ACCESS_TOKEN_KEY) : null;
}

export function AccessTokenAndXBranchRow() {
  const [accessToken, setAccessToken] = useState<string | null>(readAccessToken);
  const xBranch = useSelector(selectActiveBranchId);

  useEffect(function syncAccessTokenOnFocus() {
    const syncToken = () => setAccessToken(readAccessToken());

    syncToken();

    window.addEventListener('focus', syncToken);
    return () => window.removeEventListener('focus', syncToken);
  }, []);

  const handleCopyAccessToken = () => {
    if (!accessToken) {
      return;
    }
    copyToClipboard(accessToken);
  };

  const handleCopyXBranch = () => {
    if (!xBranch) {
      return;
    }
    copyToClipboard(xBranch);
  };

  const accessTokenLabel = getFixedTranslation('page.settings.labels.accessToken');
  const xBranchLabel = getFixedTranslation('page.settings.labels.xBranch');

  return (
    <HStack align="center" spacing={3} wrap>
      <HStack align="center" spacing={2}>
        <Text size="small" color="secondary">
          {accessTokenLabel}
        </Text>
        <IconButton
          icon="content/copy"
          onClick={handleCopyAccessToken}
          priority="secondary"
          isDisabled={!accessToken}
          aria-label={accessTokenLabel}
        />
      </HStack>
      <HStack align="center" spacing={2}>
        <Text size="small" color="secondary">
          {xBranchLabel}
        </Text>
        <IconButton
          icon="content/copy"
          onClick={handleCopyXBranch}
          priority="secondary"
          isDisabled={!xBranch}
          aria-label={xBranchLabel}
        />
      </HStack>
    </HStack>
  );
}
